/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Inspector_EditingInputs */

const cs_pipelines_inspector_editing = /** @type {(inputs: Pipelines_Inspector_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravujete…`)
};

const en_pipelines_inspector_editing = /** @type {(inputs: Pipelines_Inspector_EditingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editing…`)
};

/**
* | output |
* | --- |
* | "Editing…" |
*
* @param {Pipelines_Inspector_EditingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_inspector_editing = /** @type {((inputs?: Pipelines_Inspector_EditingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Inspector_EditingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_inspector_editing(inputs)
	return cs_pipelines_inspector_editing(inputs)
});